var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarUnselectedRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4972",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M7.805.779l.88 1.712c.214.412.623.698 1.097.764l1.97.275c1.194.167 1.67 1.574.807 2.382l-1.426 1.334c-.343.32-.5.783-.418 1.235l.336 1.883c.204 1.14-1.044 2.01-2.111 1.473l-1.763-.89a1.51 1.51 0 0 0-1.355 0l-1.762.89c-1.068.538-2.315-.332-2.112-1.473l.337-1.883a1.361 1.361 0 0 0-.418-1.235L.44 5.912c-.864-.808-.387-2.215.806-2.382l1.97-.275a1.453 1.453 0 0 0 1.096-.764L5.194.78C5.73-.26 7.271-.26 7.804.779z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarUnselectedRed);
export default __webpack_public_path__ + "static/media/star-unselected-red.00e3081e.svg";
export { ForwardRef as ReactComponent };